exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Select-clear-zone {\n  display: none;\n}\n\n.limit-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.search-error {\n  color: red;\n}\n", ""]);

// exports
